import config from 'config';
import axios from 'axios';

const ROOT = config.API_BASE_URL;

class AlertStatusesService {

  static listAll() {
    return new Promise((resolve, reject) => {
      axios.get(`${ROOT}alerts/statuses`).then((data) => {
        resolve({ alertStatuses: data.data, response: data });
      }).catch((err) => {
        reject(err);
      });
    });
  }

}

export default AlertStatusesService;
